var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M282.5 107c20.157 0 36.5 16.343 36.5 36.5S302.657 180 282.5 180 246 163.657 246 143.5s16.343-36.5 36.5-36.5zm7.807 52h-15.614c1.805 8.855 4.956 14.743 7.807 14.743 2.85 0 6.002-5.888 7.807-14.742zm-21.972.001h-11.808c3.606 6.03 9.253 10.698 15.985 13.053-1.817-3.484-3.235-7.95-4.177-13.053zm40.138 0h-11.808c-.942 5.103-2.36 9.569-4.177 13.054 6.732-2.356 12.379-7.025 15.985-13.054zM267.478 134H253.78c-.988 2.988-1.523 6.181-1.523 9.5s.535 6.513 1.523 9.5l13.699.001c-.315-3.033-.479-6.218-.479-9.501 0-3.282.164-6.468.478-9.5zm23.78 0h-17.516c-.347 2.983-.542 6.176-.542 9.5 0 3.325.195 6.517.542 9.5h17.516c.347-2.983.542-6.175.542-9.5 0-3.324-.195-6.517-.542-9.5zm19.962 0h-13.698c.233 2.244.383 4.572.445 6.96l.033 2.54c0 3.283-.164 6.468-.479 9.501h13.7c.987-2.988 1.522-6.182 1.522-9.501 0-3.319-.535-6.512-1.523-9.5zm-38.708-19.055l-.02.008c-6.724 2.357-12.363 7.023-15.966 13.047h11.809c.942-5.104 2.36-9.57 4.177-13.055zm9.988-1.688l-.13.004c-2.816.175-5.9 6.018-7.678 14.74h15.616c-1.805-8.856-4.957-14.744-7.808-14.744zm9.988 1.689l.096.185c1.772 3.459 3.156 7.856 4.081 12.87h11.809c-3.607-6.03-9.253-10.7-15.986-13.055z",
    transform: "translate(-380.000000, -2379.000000) translate(47.000000, 2272.000000) translate(87.000000, 0.000000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.8356a43165e52042b76f10f2abf4f8fb.svg";
export { ForwardRef as ReactComponent };